import React from 'react'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts'
import WrapperLoader from '../loader/WrapperLoader'

const SemiPieChart = ({ title, subtitle, data, loading }) => {
  return (
    <WrapperLoader loading={loading}>
      <div className="dashboard-tile">
        <div className="legend">
          <div className="bold">{title}</div>
          <div>{subtitle}</div>
        </div>
        <div className="pie-chart">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie startAngle={180} endAngle={0} dataKey="count" data={data} cy={180} outerRadius={80} label>
                {data.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
              </Pie>
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </WrapperLoader>
  )
}

export default SemiPieChart
